import { Hamburger } from "BaseComponents/Icons/Svg";
import { useSelector, useDispatch } from "react-redux";
import { mobileMenuActions } from "Framework/redux/actions/index";
import { BurgerButtonWrapper, Burger } from "./BurgerButtonWrapper";
import React, { useEffect } from "react";

export const HamburgerButton = ({ text, url }) => {
	const state = useSelector(({ mobileMenu }) => mobileMenu);
	const dispatch = useDispatch();

	let handleClick = (e) => {
		e.preventDefault();
		dispatch(mobileMenuActions.toggle(state.show));
	};
	let className = state.show ? "open" : "";

	return (
		<Burger>
			<BurgerButtonWrapper onClick={(e) => handleClick(e)}>
				<span className={className}></span>
				<span className={className}></span>
				<span className={className}></span>
				<span className={className}></span>
			</BurgerButtonWrapper>
		</Burger>
	);
};
